import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

class Notice extends PreLoginSessionCheck {

  render() {

    return(
      <section className="mtb whyhm pro-detail student">
        <div className="row">
          <div className="container">
            <h3>Notice</h3>
            <div style={{ marginTop: "20px",
                          padding: "20px"}}   
                          onContextMenu={(e) => e.preventDefault()} >
              
              <iframe
                src="/pdf/notice_english.pdf#toolbar=0"
                title="PDF 1"
                width="100%"
                height="1150px"
                style={{ border: "1px solid #ccc", marginBottom: "30px",  backgroundColor: "#ffffff", pointerEvents: "none" }}
              />

              <iframe
                src="/pdf/notice_tamil.pdf#toolbar=0"
                title="PDF 2"
                width="100%"
                height="1700px"
                style={{ border: "1px solid #ccc" , pointerEvents: "none",  backgroundColor: "#ffffff" }}
              />

            </div>

          </div>
        </div>
      </section>
    );
  }
}

export default Notice;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Notice.js